/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/no-array-index-key */

/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactMarkdown from 'react-markdown';

import { convertToNewLine } from '../../core/helpers';
import LinkRenderer from '../LinkRenderer/LinkRenderer';

interface IProps {
  className?: string;
  components?: any;
  children?: any;
}

const tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];

const MarkdownElement = (Tag: any) =>
  function Component({ node, children, ...props }: any) {
    return <Tag {...props}>{convertToNewLine(children)}</Tag>;
  };

function Markdown({ className, components, children }: IProps) {
  return (
    <ReactMarkdown
      className={`${className ? `${className}` : ''}`}
      components={{
        a: LinkRenderer,
        ...Object.fromEntries(tags.map((tag) => [tag, MarkdownElement(tag)])),
        ...components,
      }}
    >
      {children}
    </ReactMarkdown>
  );
}

export default Markdown;
